import Vue from 'vue';
import ResizableColumns from '@spacebnd/vuetify-data-table-resizable-columns';
import { keycloak_plugin } from './plugins/keycloak';
import App from './App.vue';
import router from './router';
import { store } from './store';
import {
  vuetify, VueTheMask, dialog,
} from './plugins';
import { VMoney } from './plugins/v-money';
import register_filters from './filters';
import { KeyCloak } from './plugins/keycloak/types';
import './scss/main.scss';

register_filters();

Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(VMoney);
Vue.use(dialog);
Vue.use(keycloak_plugin);
Vue.use(ResizableColumns);

// keycloak

Vue.keycloak_instance
  .init({
    onLoad: KeyCloak.KeyCloakOnLoad.LOGIN_REQUIRED,
  })
  .then((authenticated: boolean) => {
    if (authenticated) {
      new Vue({
        el: '#app',
        router,
        store,
        vuetify,
        render: (h) => h(App),
      }).$mount('#app');
    }
  })
  .catch((error: unknown) => console.error('keycloak init error:', error));
